import { useAuth } from '@/hooks/useAuth';
import { AccessDenied } from '@/pages/AccessDenied';

/**
 * Permission-based PM portal guard (EP-07 / SA-00, ADR 011 D3).
 *
 * Gated on `hasPermission('organization', 'update')` instead of strict role
 * equality. This works for:
 *   - property_manager (has `organization: [read, update]`)
 *   - super_admin (has `organization: [create, read, update, delete]`)
 *
 * The component name is kept for backward compatibility with existing
 * callers in App.tsx. Use `RequirePermission` directly when a route needs
 * a different resource/action gate.
 *
 * @see RequirePermission for finer-grained per-route gates.
 */
export function RequirePM({ children }: { children: React.ReactNode }) {
  const { hasPermission, isLoading } = useAuth();
  if (isLoading) {
    return null;
  }
  if (!hasPermission('organization', 'update')) {
    return <AccessDenied />;
  }
  return <>{children}</>;
}